import { colours, fontSizes } from "../../constants/css";
import styled from 'styled-components';
var StyledSkipLinks = styled.div.withConfig({
  displayName: "style__StyledSkipLinks",
  componentId: "sc-veesww-0"
})([".skiplinks{position:absolute;top:0;left:0;width:100%;margin:0;li{font-size:", ";list-style:none;a{position:absolute;left:-9999em;z-index:4;white-space:nowrap;color:", ";padding:1rem;display:block;width:100%;}a:focus,a:active{left:0;background-color:", ";outline:none;}}z-index:100001;}"], fontSizes.large, colours.qantasDarkerGrey, colours.qantasLightBlue);
export { StyledSkipLinks };